import React, { useCallback, useState } from 'react'
import fileDownload from 'js-file-download'

import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks/effects'

import { generateScrapingVerificationReport } from '../../rest'
import { ScrapingVerificationReportForm } from '../forms'

const ScrapingVerificationReportPage = () => {
  useDocumentTitle('Reports - Scraping Verification')
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)

  const generateReport = useCallback(
    async filters => {
      const { dateRange, userIds } = filters

      try {
        setIsGeneratingReport(true)
        const [startDateMoment, endDateMoment] = dateRange
        const reportReponse = await generateScrapingVerificationReport({
          startDate: startDateMoment.format('YYYY-MM-DD'),
          endDate: endDateMoment.format('YYYY-MM-DD'),
          userIds,
        })

        fileDownload(reportReponse.data, 'ScrapingVerificationReport.zip')
        setIsGeneratingReport(false)
      } catch ({ response }) {
        showErrorNotification({
          message: 'Failed to generate report.',
          description: response.statusText,
        })
      }
    },
    [setIsGeneratingReport],
  )

  const handleSubmit = useCallback(filters => generateReport(filters), [
    generateReport,
  ])

  return (
    <ScrapingVerificationReportForm
      onSubmit={handleSubmit}
      isGeneratingReport={isGeneratingReport}
    />
  )
}

export default ScrapingVerificationReportPage
